import React from "react";
import { css } from "@emotion/css";
import "rc-tooltip/assets/bootstrap.css";
import TooltipWrapper from "./TooltipWrapper";

interface IconTooltipProps {
    text?: string;
    className?: string;
    place?: string;
    replacementContentStyle?: string;
    /** When provided, renders this image as the tooltip trigger instead of the default ? badge. */
    icon?: string;
    /** Max width for the tooltip bubble (pixels or CSS string). Only used when icon is set. */
    maxWidth?: number | string;
}

const IconTooltip: React.FC<IconTooltipProps> = (props) => (
    <TooltipWrapper
        place={props.place === undefined ? "top" : props.place}
        text={props.text}
        replacementContentStyle={props.replacementContentStyle}
        maxWidth={props.icon ? (props.maxWidth ?? 280) : undefined}
    >
        {props.icon ? (
            <img
                src={props.icon}
                alt="info"
                className={`${infoIconStyle} ${props.className ?? ""}`}
            />
        ) : (
            <div className={`${badgeStyle} ${props.className ?? ""}`}>
                <span>?</span>
            </div>
        )}
    </TooltipWrapper>
);

const badgeStyle = css`
    width: 17px;
    height: 17px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    span {
        width: 6px;
        height: 17px;
        font-family: sans-serif;
        font-size: 12px;
        font-style: normal;
        font-stretch: normal;
        line-height: 17px;
        letter-spacing: 0.5px;
        color: #007dbb;
    }
`;

const infoIconStyle = css`
    width: 16px;
    height: 16px;
    opacity: 0.55;
    cursor: pointer;
    transition: opacity 0.15s;
    flex-shrink: 0;
    vertical-align: middle;
    display: block;
    &:hover {
        opacity: 1;
    }
`;

export default IconTooltip;
